import React, { useState } from "react";
import {
  Dialog,
  DialogContent,
  DialogHeader,
  DialogTitle,
  DialogTrigger,
  DialogClose,
} from "./ui/dialog";
import { Button } from "./ui/button";
import { ChevronDown } from "lucide-react";

const SelectLanguage = ({ getLanguage }) => {
  const [selectedLanguage, setSelectedLanguage] = useState("English (UK)");

  getLanguage(selectedLanguage);

  const languages = [
    { code: "EN", name: "English (UK)" },
    { code: "EN", name: "English (AU)" },
    { code: "EN", name: "English (US)" },
  ];

  return (
    <Dialog>
      <DialogTrigger asChild>
        <Button
          variant="ghost"
          className="relative w-40 h-10 rounded-full bg-transparent  border border-gray-100 border-opacity-35  text-text-secondary  flex justify-between px-4"
        >
          <span className="text-sm font-semibold">{selectedLanguage}</span>
          <ChevronDown className="w-4 h-4 text-gray-500" />
        </Button>
      </DialogTrigger>
      <DialogContent className="max-w-md p-6 rounded-lg shadow-lg">
        <DialogHeader>
          <DialogTitle className="text-lg font-semibold text-gray-700 mt-5">
            Select a display language
          </DialogTitle>
          <p className="text-sm text-gray-500">
            Choose your preferred language for the platform's interface.
          </p>
        </DialogHeader>
        <div className="mt-4 max-h-[250px]">
          <DialogClose className="w-full space-y-2">
            {languages.map((language) => (
              <div
                key={language.name}
                onClick={() => setSelectedLanguage(language.name)}
                className={`flex items-center justify-between px-4 py-3 cursor-pointer border rounded-md ${
                  selectedLanguage === language.name
                    ? "border-rose-500"
                    : "border-gray-200"
                } hover:bg-gray-100`}
              >
                <div className="flex items-center gap-2">
                  <span className="w-7 h-7 flex items-center justify-center bg-rose-600 text-white font-bold rounded-full">
                    {language.code}
                  </span>
                  <span className="text-sm font-medium text-gray-800">
                    {language.name}
                  </span>
                </div>
              </div>
            ))}
          </DialogClose>
        </div>
      </DialogContent>
    </Dialog>
  );
};

export default SelectLanguage;
